/**
 * Different types of AvatarSize.
 * @public
 */
enum AvatarSize {
	/**
	 * component size - 2rem
	 * font size - 1rem
	 * @public
	 */
	XS = "XS",

	/**
	 * component size - 3rem
	 * font size - 1.5rem
	 * @public
	 */
	S = "S",

	/**
	 * component size - 4rem
	 * font size - 2rem
	 * @public
	 */
	M = "M",

	/**
	 * component size - 5rem
	 * font size - 2.5rem
	 * @public
	 */
	L = "L",

	/**
	 * component size - 7rem
	 * font size - 3rem
	 * @public
	 */
	XL = "XL",
}

export default AvatarSize;
